import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import isEmpty from 'lodash/isEmpty'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useCollapsableTransactions } from 'modules/expenses/components/expenses/Detail/_BasicInformation/useCollapsableTransactions'
import { CustomTwoColumnsList } from 'modules/expenses/components/expenses/Detail/_Form/Common/ConfirmationScreen/CustomTwoColumnList'
import { transactionsFromExpensable } from 'modules/expenses/lib/transactions/transactionsFromExpensable'
import { Expensable } from 'modules/expenses/types/Expensable'

interface TransactionsDetailsWidgetProps {
  expensable: Expensable
}

const TransactionsDetailsWidget = ({ expensable }: TransactionsDetailsWidgetProps) => {
  const {
    company: { locale },
  } = useCurrentSession()

  const transactions = transactionsFromExpensable(expensable)

  const transactionList = useCollapsableTransactions(transactions, locale || '')

  if (isEmpty(transactionList) || transactionList.length === 1) {
    return null
  }

  const buildTransactions = () => {
    return transactionList.map((transaction) => {
      return {
        title: transaction.date,
        info: transaction.amount,
        link: transaction.to,
      }
    })
  }

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.transaction_details_block.title'),
        }}
      >
        <CustomTwoColumnsList list={buildTransactions()} />
      </Widget>
    </Box>
  )
}

export default TransactionsDetailsWidget
